import { GetStaticProps } from "next";
import ContentService from "@/src/ContentService";
import { ICategory, IPost } from "@/src/@types/contentful";
import { BlogLandingPageProps } from "@/src/pages/BlogLandingPage";
import { IDetailPreviewCard } from "@/src/@types/blog";
import { ContentUtils } from "@/src/ContentUtils";
import { BlogUtils } from "@/src/BlogUtils";
import { IIcon } from "@/src/components/molecules/CircleImageCarousel/Icon";
import { PrivateSettings } from "@/src/config/PrivateSettings";
import { contentTypes } from "@/src/utils/search.constants";
import DefaultPage from "@/src/pages/BlogLandingPage";
import { BrandService } from "@/src/BrandService";
import { Utils } from "@/src/Utils";
export default DefaultPage;

export const getStaticProps: GetStaticProps<BlogLandingPageProps> = async context => {
    const pageNumber = Number((context.params?.page as string) ?? "1");
    const contentContext = ContentService.createContentContextFromNextContext(context);

    if (isNaN(pageNumber)) {
        return {
            notFound: true
        };
    }

    const blogPosts = await ContentService.query<IPost>(
        {
            "fields.redirectToUrl[exists]": false,
            "fields.disableInLocale[nin]": BrandService.getCurrentBrandData().country,
            content_type: contentTypes.post
        },
        {
            orderBy: "-fields.publishDate",
            page: {
                number: pageNumber,
                size: 9
            }
        },
        contentContext
    );

    const blogCards: IDetailPreviewCard[] = blogPosts.items.map(item => BlogUtils.createPreviewCard(item, "post"));
    const featuredBlogCards = (await ContentUtils.getFeaturedPosts(contentContext)).map(item => BlogUtils.createPreviewCard(item, "post"));
    const topBlogCards = (await ContentUtils.getTopPosts(contentContext)).map(item => BlogUtils.createPreviewCard(item, "post"));

    const categories = await ContentService.getEntriesByType<ICategory>(
        "category",
        {
            orderBy: "fields.name"
        },
        contentContext
    );

    const categoryIcons: IIcon[] = categories.items.map(category => ({
        url: `/blog/${category.fields.slug}`,
        imageURL: !!category.fields.largeIcon?.fields.file.url ? `https:${category.fields.largeIcon?.fields.file.url}` : null,
        text: category.fields.name,
        id: category.sys.id
    }));

    const props: BlogLandingPageProps = {
        blogCards: blogCards,
        featuredBlogCards: featuredBlogCards,
        topBlogCards: topBlogCards,
        categories: categoryIcons,
        pageNumber: blogPosts.pageNumber,
        totalPages: blogPosts.totalPages,
        contentType: contentTypes.post
    };

    return {
        props: Utils.cleanUndefinedValues(props),
        revalidate: PrivateSettings.DEFAULT_ISR_REVALIDATION_TIME_IN_SECONDS
    };
};
